<template>
    <div>
        <van-popup class="base-popup" v-model="show">
            <div class="container">
                <div class="title-box">
                    <img class="wx-logo" src="@/assets/images/home/wx.png" alt="">
                    <div class="title">微信授权提示</div>
                </div>
                <div class="message">
                    您的账号暂未进行微信授权，为了不影响您的使用，请立即进行授权。
                </div>
                <div class="btns">
                    <div class="btn cancel-btn" @click="show = false">暂不授权</div>
                    <div class="btn save-btn" @click="confirm">立即授权</div>
                </div>
            </div>
        </van-popup>

        <PageLoading ref="pageLoadingRef"></PageLoading>
    </div>
</template>
<script>
import appSDK from '@/utils/appSDK';
import HomeApi from '@/api/home';

export default {
    data() {
        return {
            show: false,
            content: '',
        };
    },
    methods: {
        init() {
            this.show = true;
        },
        async confirm() {
            const wxCode = await appSDK.wxAuth()
            try {
                this.$refs.pageLoadingRef.open();
                await HomeApi.wechatAuth({
                    code: wxCode,
                })
                this.$toast('微信授权成功');
                this.show = false;
                this.$emit('success');
            } finally {
                this.$refs.pageLoadingRef.close();
            }
        }
    }
}
</script>
<style scoped lang="scss">
.container {
    padding: 20px;
}

.title-box {
    display: flex;
    flex-direction: column;
    align-items: center;

    .wx-logo {
        width: 60px;
        height: 60px;
    }

    .title {
        margin-top: 20px;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        line-height: 22px;
    }
}

.message {
    margin-top: 20px;
    font-size: 15px;
    color: #333333;
    line-height: 22px;
    text-align: center;
}

.btns {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;

    .btn {
        width: 124px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 45px;
        font-weight: 500;
    }

    .cancel-btn {
        background: #FFFFFF;
        border: 1px solid #E6E6E6;
        font-size: 16px;
        color: #333333;
    }

    .save-btn {
        background: #007FFE;
        border: none;
        font-size: 16px;
        color: #fff;
    }
}

.base-popup {
    border-radius: 8px;
    width: 303px;
}
</style>